export default __webpack_public_path__ + "static/jet-setter-a7bcba1584e44ceb7fe12cb0893fb3e3.png";